import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

export const booleanFilter = [
  createFilter({
    name: 'isChecked',
    self: t.boolean.instance(),
    args: [],
    label: 'Está marcado',
    shortString: () => ': Checked',
    impl: value => {
      return !!value;
    },
    defaultValue: () => true,
  }),
  createFilter({
    name: 'isUnchecked',
    self: t.boolean.instance(),
    args: [],
    label: 'Está desmarcado',
    shortString: () => ': Unchecked',
    impl: value => {
      return !value;
    },
    defaultValue: () => false,
  }),
];
